import { render, staticRenderFns } from "./FormatTypePicker.vue?vue&type=template&id=a5a0a66a&scoped=true&"
import script from "./FormatTypePicker.vue?vue&type=script&lang=js&"
export * from "./FormatTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./FormatTypePicker.vue?vue&type=style&index=0&id=a5a0a66a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a0a66a",
  null
  
)

export default component.exports